module.exports = __webpack_public_path__ + "img/comochegar01.84eeb96d.jpg";